module.exports = __webpack_public_path__ + "img/32.8.TSS.f7475478.png";